
import 'signalr'
import global from '../global'

class SignalRService {
  constructor() {
    this.connection = null
    this.hubProxy = null
  }

  startConnection(userId) {
    if (!window.jQuery || !window.jQuery.connection) {
      console.error('SignalR dependencies not loaded')
      return
    }
    // Initialize connection
    /* eslint-disable */
    this.connection = $.hubConnection(global.signalRHubUrl, {
      useDefaultPath: false,
    })
    // this.connection = $.hubConnection('http://localhost:8989/signalr', {
    //   useDefaultPath: false,
    // })
    /* eslint-enable */
    
    // Create hub proxy
    this.hubProxy = this.connection.createHubProxy('MessageHub')
    
    // Register client methods
    this.hubProxy.on('ShowMessage', (message) => {
      if (this.notificationHandler) {
        this.notificationHandler(message)
      }
    })

    // Start connection
    this.connection.start()
      .done(() => {
        console.log('SignalR connected')
        this.hubProxy.invoke('Subscribe', userId)
      })
      .fail(err => console.error('SignalR Connection Error:', err))
  }

  stopConnection() {
    if (this.connection) {
      this.connection.stop()
    }
  }

  registerNotificationHandler(handler) {
    this.notificationHandler = handler
  }
}

export default new SignalRService()